import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { options } from "../../utils/richTextOptions";
import { Link } from "gatsby";
import {getCurrentPath} from "../../utils/getCurrentPath";

const Header = ({ backgroundImage, description, features }) => {
  return (
    <div className="w-full min-h-[710px] sm:min-h-[478px] h-full text-white relative overflow-y-hidden tracking-wide box-border">
      {backgroundImage?.gatsbyImageData && (
        <div className="absolute top-0 left-0 w-full h-full">
          <GatsbyImage
            image={backgroundImage.gatsbyImageData}
            alt={backgroundImage.title}
            objectFit="cover"
            objectPosition="center"
            className="joinclub_backgroundImage"
          />
        </div>
      )}
      <div className="w-full h-full absolute top-0 left-0 z-[1] bg-black/40 px-5">
        <div className="w-full mx-auto">
          <div className="max-w-2xl w-full mx-auto text-center pt-[30px] mb-1 space-y-5 md:space-y-10">
            <h1 className="text-3xl md:text-[40px] tracking-wide md:leading-[60px] font-semibold">
              Sign up to The Bushbuck Club
            </h1>
            <div className="text-[15px] md:text-xl leading-[27px] md:leading-7 tracking-wide font-medium">
              {documentToReactComponents(JSON.parse(description.raw), options)}
            </div>
          </div>

          <div className="max-w-[1008px] w-full mx-auto grid grid-cols-2 gap-10 sm:flex sm:items-start sm:justify-between mb-8 md:mb-12 mt-6 md:mt-8 ">
            {features.map((feature, index) => (
              <div
                key={index}
                className="flex flex-col items-center sm:justify-center text-center sm:px-2 space-y-2 sm:space-y-[14px] sm:w-[170px]"
              >
                <GatsbyImage
                  image={feature.image.gatsbyImageData}
                  alt={feature.image.title}
                  objectFit="contain"
                  className="w-10 md:w-16 h-10 md:h-16 object-contain"
                />
                <h4 className="text-base md:text-xl font-bold">
                  {feature.title}
                </h4>
              </div>
            ))}
          </div>

          <div className="max-w-[526px] w-full mx-auto text-center mt-14 sm:mt-20 md:mt-0">
            <div className="block text-center font-normal mt-8 mb-4">
              <p className="text-base md:text-lg text-center tracking-wide inline-block">
                Already a Bushbuck Club Member?{" "}
                <Link
                  to="/account/login"
                  state={{redirectTo: getCurrentPath()}}
                  className="inline-block tracking-normal text-sm font-bold uppercase underline underline-offset-2"
                >
                  Login here
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
